export default "__VITE_ASSET__tqa4R9r2__"